import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";
import { HiringSectionNav } from "./-components/hiring-section-nav";

export const Route = createFileRoute("/_authenticated/_workforce/hiring")({
  beforeLoad: ({ context }) => guardRoute(context.me, "hiring"),
  component: HiringSection,
});

/** The frame every hiring screen sits in: one strip naming the sections, then the section itself. A
 * recruiter moves between the pipeline, the candidates and the postings all day, so they are one
 * click apart rather than a trip back through the sidebar. */
function HiringSection() {
  return (
    <>
      <HiringSectionNav />
      <Outlet />
    </>
  );
}
